// @flow
import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { RouteNames } from 'router';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { PageLoader } from 'components/molecules/pageLoader';
import FooterSection from 'components/templates/footer';
import PageTemplate from 'components/templates/pageTemplate';
import { StaticContentSection } from 'components/templates/staticContentSection';
import { useViewport } from 'components/templates/viewportProvider';
import type { AppState } from 'modules/rootReducer';
import type { SiteSettings, Vertical } from 'types/common';
import RenderSEO from 'components/atoms/renderSEO';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';

type Props = {
  isLoading: boolean,
  verticals: Array<Vertical>,
  getVerticals: () => void,
  siteSettings: SiteSettings,
  getSiteSettings: () => void,
};

const TermsAndConditions = (props: Props) => {
  const {
    isLoading,
    getVerticals,
    verticals,
    getSiteSettings,
    siteSettings,
    getBannerData,
    getPageData,
    bannerData,
    cmsPageData,
    footerLink,
    getFooterLinkData,
  } = props;

  const metaTagSEO = {
    metaTitle: 'Terms and Conditions - Total Environment',
    metaDescription: '',
    metaKeywords: '',
  };

  const { isMobile } = useViewport();
  let [theme, setTheme] = useState('light-theme');

  useEffect(() => {
    getVerticals();
    getSiteSettings();
    getBannerData();
    getPageData();
    getFooterLinkData();
  }, []);

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !siteSettings ||
    !footerLink ||
    !verticals ||
    !bannerData ||
    !cmsPageData
  ) {
    return null;
  }

  const componentList = [
    {
      component: StaticContentSection,
      data: { html: termsHTML, isScroll: false, toggleId: false },
      location: props,
      sectionId: 'terms',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Terms & Conditions',
          breadcrumbLink: RouteNames.conditions,
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Terms and Conditions',
          breadcrumbLink: RouteNames.conditions,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <>
      <RenderSEO metaTags={metaTagSEO} />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        showGetInTouch={false}
        showShareButton={false}
      />
    </>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading:
      HomeSelector.getVerticalsLoading(state) ||
      FooterSelector.isLoading(state) ||
      HomeSelector.getSiteSettingsLoading(state),
    verticals: HomeSelector.getVerticals(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    bannerData: HomeSelector.getBannerData(state),
    footerLink: FooterSelector.getFooterData(state),
    cmsPageData: CmsPagesSelector.getPageData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getVerticals, getSiteSettings, getBannerData } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getFooterLinkData } = FooterActions;
  return bindActionCreators(
    {
      getVerticals,
      getSiteSettings,
      getBannerData,
      getPageData,
      getFooterLinkData,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditions);

const termsHTML = `
<div>
  <h1>Terms & Conditions</h1>
    <div>
    <p>Tickets once booked cannot be exchanged, refunded or postponed.</p>
    <p>We recommend that you arrive at-least 30 minutes prior at the venue for a seamless entry.</p>
    <p>Unlawful resale (or attempted unlawful resale) of a ticket would lead to seizure or cancellation of that ticket.</p>
    <p>Right of admission reserved.</p>
    <p>Management reserves the right to cancel the event.</p>
    <p>These terms and conditions are subject to change from time to time at the discretion of Total Environment Music Foundation.</p>
  </div>
</div>
`;
